import React, { useState, useEffect } from 'react';
//import '../css/blog.css';
import { GetPostTags, getRandomLightColor } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const TagItems = (postSlugObject) => {
  const [postTags, setPostTags] = useState([]);

  const fillPostTags = async () => {
    try {
      const postTagsList = await GetPostTags(postSlugObject.postSlug);
      const jsonPostTagList = JSON.parse(postTagsList);
      setPostTags(jsonPostTagList);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillPostTags();
  }, []);

  const tagNames = postTags.map(tag => tag.tagname).join(', ');

  return (
    <>
      <div className="tag-section">

        <div className="tag-item">
          {postTags.length > 0 ? (
            postTags.slice(0, 5).map((item, index) => (
              <span className="tag-block">
              <span key={index} style={{ backgroundColor: getRandomLightColor(), borderRadius: "12px", padding: "5px 15px", marginRight: "20px" }}>
                <a href={"/tag/" + item.paramlink} className="no-underline">{item.tagname}</a>
              </span>
              </span>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default TagItems;